module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ3_2.39e77f1a.svg";